import { getPatientIdFromPath } from '@/shared/lib/util/constants';
import { pickQuestionIdeas } from '@/shared/lib/util/questionIdeas';
import { useAccountStore } from '@/shared/model/AccountStore';
import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

/** Picks fresh question ideas for the page that is open, each time it is called. */
export const useAiSearchQuestionIdeas = () => {
  const { pathname } = useLocation();
  const account = useAccountStore(state => state.account);

  return useCallback(() => {
    const truentityId = getPatientIdFromPath(pathname);
    // The store keeps the last patient after leaving their page, so the name only counts on theirs.
    const name =
      truentityId && account?.truentityId === truentityId
        ? [account.user?.firstName, account.user?.lastName].filter(Boolean).join(' ')
        : null;
    return pickQuestionIdeas(pathname, { isOpen: Boolean(truentityId), name: name || null });
  }, [pathname, account]);
};
